module.exports = __webpack_public_path__ + "static/harry-potter-and-the-halfblood-prince-4bc5283c1067fcd955b31002467979e3.jpg";